<template>
    <div>
        <button
            type="button"
            v-if="hasLookup"
            :disabled="!reference"
            @click="performLookup"
            :class="['btn shadow-none btn-block btn-sm mt-2', reference ? 'btn-primary' : 'bg-dark-5 text-white']"
        >
            Verify
        </button>
        <div v-if="loading" class="text-center py-3">
            <i class="fas fa-spinner fa-2x fa-pulse text-primary"></i>
        </div>
        <div v-if="lookupResult" class="mt-2">
            <lookup-result :result="lookupResult" :name="corporateName" />
        </div>
        <hr />
    </div>
</template>

<script>
import LookupResult from '../../../components/corporate/settings/biller/LookupResult.vue';
import axios from 'axios';

export default {
    name: 'ConsumerLookup',
    components: { LookupResult },
    props: {
        corporateId: {
            type: [Number, String],
            required: true,
            validator: function(value) {
                if (value === null || value === undefined) return false;
                const num = Number(value);
                return !isNaN(num) && Number.isInteger(num);
            }
        },
        corporateName: {
            type: String,
            required: true,
            validator: function(value) {
                return value !== null && value !== undefined && typeof value === 'string';
            }
        },
        reference: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            hasLookup: false,
            lookupResult: null,
            loading:  false
        };
    },
    mounted() {
       this.checkLookup();
    },

    methods: {
        async checkLookup() {
            this.lookupResult = null;
            this.loading = true;
            try {
                const corporateId = Number(this.corporateId);
                const response = await axios.get(`/billers/lookup/check/${corporateId}`);
                this.loading = false;
                this.hasLookup = response.data.has_lookup === true;
                this.$emit('has-lookup', this.hasLookup);
            } catch (e) {
                this.loading = false;
                this.hasLookup = false;
            }
        },
        async performLookup() {
            this.lookupResult = null;
            this.loading = true;
            try {
                const response = await axios.post(`/billers/lookup/${this.corporateId}`, {
                    account_id: this.reference
                });
                this.lookupResult = response.data.body.lookup_result;
                this.loading = false;
                if (
                    this.lookupResult?.message === 'Account found' &&
                    this.lookupResult?.data &&
                    Object.keys(this.lookupResult.data).length > 0
                ) {
                    this.$emit('found');
                }

            } catch (e) {
                this.loading = false;
                this.$emit('not-found');
            }
        }
    }
}
</script>
